import { create } from "zustand";
import { ProductVariantInterface } from "../constants/Product";

interface ProductVariantState {
  variants: ProductVariantInterface[];
  addVariant: (variant: ProductVariantInterface, note?: string) => void;
  removeVariant: (variantId: any) => void;
  updateVariant: (variant: ProductVariantInterface) => void;
  clearVariant: () => void;
}

export const useProductVariantStore = create<ProductVariantState>((set) => ({
  variants: [],
  addVariant: (variant, note) =>
    set((state) => {
      if (note) {
        const exists = state.variants.some((v) => v.tempId === variant.tempId);
        if (!exists) {
          return { variants: [...state.variants, variant] };
        }
        return state;
      }
      return { variants: [...state.variants, variant] };
    }),
  removeVariant: (variantId) =>
    set((state) => ({
      variants: state.variants.filter((v) => v.tempId !== variantId),
    })),
  updateVariant: (updatedVariant) =>
    set((state) => ({
      variants: state.variants.map((variant) =>
        variant.tempId === updatedVariant.tempId ? updatedVariant : variant
      ),
    })),
  clearVariant: () => set((state) => ({ variants: [] })),
}));
